export const IMAGE_FORMATS = ['jpeg', 'png', 'jpg', 'webp', 'svg', 'heic'];
export const VIDEO_FORMATS = ['mp4', 'hevc', 'webm', 'mov'];
export const AUDIO_FORMATS = ['mp3', 'wav', 'aac', 'ogg', 'm4a'];
export const DEFAULT_FORMATS = [...IMAGE_FORMATS, ...VIDEO_FORMATS];

export const VIDEO_MAX_SIZE = 100 * 1024 * 1024;
export const AUDIO_MAX_SIZE = 50 * 1024 * 1024;
